// Числовые поля (количество, цена, вес): при входе в поле старое значение выделяется целиком,
// поэтому ввод сразу заменяет его, а не дописывается к прежним цифрам.
// Работает для всех числовых полей программы: Mantine NumberInput (inputmode="decimal"/"numeric")
// и обычных <input type="number">. Повторный щелчок в уже активном поле ставит курсор как обычно.
function isNumericField(el: EventTarget | null): el is HTMLInputElement {
  if (!(el instanceof HTMLInputElement) || el.readOnly || el.disabled) return false;
  const mode = (el.getAttribute('inputmode') ?? '').toLowerCase();
  return el.type === 'number' || mode === 'decimal' || mode === 'numeric';
}

export function installSelectOnFocus(doc: Document = document): void {
  doc.addEventListener('focusin', (e) => {
    const el = e.target;
    if (!isNumericField(el)) return;
    el.select();
    // щелчок мышью: браузер после фокуса ставит курсор и снимает выделение — отменяем это один раз
    const keep = (ev: Event) => { ev.preventDefault(); el.select(); };
    el.addEventListener('mouseup', keep, { once: true });
    // если фокус пришёл с клавиатуры (Tab/Enter) — mouseup не будет; снимаем обработчик при уходе
    el.addEventListener('blur', () => el.removeEventListener('mouseup', keep), { once: true });
  });
}
